module.exports = __webpack_public_path__ + "media/images/loading-ec41fa1e597470abfb450935dca84cbd.gif";